import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tchr-content',
  imports: [],
  templateUrl: './tchr-content.component.html',
  styleUrls: ['./tchr-content.component.scss'],
})
export class TchrContentComponent {
  @Input() user: any;
}
